/**
 * @prettier
 */

/**
 * Scenario for Regula processing
 *
 * @type string
 */
const processingScenario = 'MrzOrLocate';

/**
 * Codes relating to cropped and uncropped images
 *
 * @type object
 */
const containerTypes = {
    cropped: 1,
    uncropped: 16,
};

/**
 * Codes relating to front image
 *
 * @type object
 */
const fieldNames = {
    front: 'Document front side',
};

/**
 * Recogniser Configuration
 *
 * @type object
 */
const recognizerProcessParam = {
    processParam: {
        returnUncroppedImage: true,
        timeout: 30000,
        scenario: processingScenario,
        imageQa: {
            documentPositionIndent: 10,
            expectedPass: ['dpiThreshold', 'glaresCheck', 'focusCheck'],
            dpiThreshold: 420,
            glaresCheck: true,
            glaresCheckParams: {
                imgMarginPart: 0.05,
                maxGlaringPart: 0.01,
            },
        },
    },
};

/**
 * Image Process Configuration
 *
 * @type object
 */
const imageProcessParam = {
    processParam: {
        scenario: processingScenario,
        resultTypeOutput: [37, 30],
        returnUncroppedImage: true,
    },
};

/**
 * Settings for Document Reader Compinent
 *
 * @type object
 */
const documentReaderSettings = {
    closeButton: false,
    copyright: false,
    cameraFramePortraitAspectRatio: true,
    resolution: { width: 3840, height: 2160 },
};

export {
    imageProcessParam,
    recognizerProcessParam,
    fieldNames,
    containerTypes,
    processingScenario,
    documentReaderSettings,
};
